var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotVerified({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.1943 3.24288C12.0185 2.77409 11.4448 2.5248 10.9934 2.74049C10.385 3.0312 9.591 3.34617 9.00676 3.34617C8.39443 3.34617 7.5517 3.00019 6.9337 2.69876C6.50961 2.49192 5.973 2.69704 5.78371 3.12962C5.51517 3.74334 5.08267 4.5593 4.48623 5.15641C3.94432 5.69892 3.26708 6.06078 2.7249 6.28711C2.26924 6.47732 2.0304 7.04576 2.24392 7.49138C2.53701 8.10308 2.85884 8.90942 2.85884 9.50098C2.85884 10.1226 2.50345 10.9814 2.19948 11.6023C1.99583 12.0183 2.18775 12.5452 2.60456 12.7463C3.16408 13.0164 3.90342 13.4431 4.48623 14.0266C5.05817 14.5992 5.47936 15.3227 5.74979 15.8788C5.95712 16.3052 6.5135 16.5078 6.93946 16.3003C7.55688 15.9996 8.39621 15.6558 9.00676 15.6558C9.59765 15.6558 10.4031 15.978 11.0141 16.2714C11.4592 16.4851 12.027 16.246 12.217 15.7899C12.4431 15.2471 12.8046 14.5691 13.3465 14.0266C13.9429 13.4295 14.758 12.9965 15.371 12.7276C15.8031 12.5381 16.008 12.0009 15.8014 11.5764C15.5003 10.9577 15.1547 10.114 15.1547 9.50098C15.1547 8.91609 15.4693 8.12121 15.7597 7.51212C15.9751 7.06022 15.7261 6.48583 15.2579 6.30986C14.6604 6.08533 13.9069 5.71748 13.3465 5.15641C12.786 4.59534 12.4186 3.84105 12.1943 3.24288Z",
    fill: "#74747B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3652 11.9574L6.72695 7.31915M6.72695 11.9574L11.3652 7.31915",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotVerified);
export default __webpack_public_path__ + "static/media/not-verified.651e2d1e60e80b2393be69bbe7d6ada9.svg";
export { ForwardRef as ReactComponent };